const tester =
  /^[\w!#$%&'*+/=?^{|}~-]+(\.?[\w!#$%&'*+/=?^{|}~-]+)*@[\dA-Za-z-]+(\.[A-Za-z-]{2,})+$/;

export function isValidEmail(email: string) {
  if (!email) return false;

  const emailParts = email.split("@");

  if (emailParts.length !== 2) return false;

  const account = emailParts[0];
  const address = emailParts[1];

  if (account.length > 64) return false;
  else if (address.length > 255) return false;

  const domainParts = address.split(".");
  if (
    domainParts.some(function (part) {
      return part.length > 63;
    })
  )
    return false;

  if (!tester.test(email)) return false;

  return true;
}
